<template>
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4997 23.4165C18.2526 23.4165 22.9163 18.7529 22.9163 13C22.9163 7.24713 18.2526 2.5835 12.4997 2.5835C6.74671 2.5835 2.08301 7.24713 2.08301 13C2.08301 18.7529 6.74671 23.4165 12.4997 23.4165Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 8.83301V12.9996"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 16.125L12.5 17.1667"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
</template>
